module.exports = __webpack_public_path__ + "img/media (11).9d9b4de5.png";